import React from "react";
import { Tooltip, Dropdown, Menu } from "antd";
import { EyeFilled, MoreOutlined } from "@ant-design/icons";
import CustomTitle from "../../../components/CustomTitle";
import CustomParagraph from "../../../components/CustomParagraph";
import { useNavigate } from "react-router-dom";

const NotificationListItem = ({
  title,
  subtitle,
  user,
  visible,
  sensors,
  onEdit,
  onDelete,
  item,
  isCompanyLevel,
}) => {
  const navigate = useNavigate();
  console.log({ item, isCompanyLevel });
  const handleMenuClick = ({ key }) => {
    if (key === "edit") {
      onEdit?.();
    } else if (key === "delete") {
      onDelete?.(); 
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="edit">Edit</Menu.Item>
      <Menu.Item key="delete">Delete</Menu.Item>
    </Menu>
  );

  console.log("MAPPED USERS:", item);

  return (
    <div
      style={{
        padding: "12px 0",
        display: "flex",
        justifyContent: "space-between",
        gap: 16,
      }}
    >
      <div style={{ minWidth: 250 }}>
        <CustomTitle
          text={isCompanyLevel ? item?.type : item?.title}
          fontSize="12px"
          fontWeight="400"
          marginBottom="2px"
        />

        <p style={{ fontSize: 12, color: "#5E5E5E", margin: 0 }}>
          {isCompanyLevel ? (
            item?.frequency || "—"
          ) : Array.isArray(item?.sub_title) && item.sub_title.length > 0 ? (
            <>
              {item.sub_title[0]}
              {item.sub_title.length > 1 && (
                <>
                  ,{" "}
                  <Tooltip title={item.sub_title.slice(1).join(", ")}>
                    <span
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                    >
                      +{item.sub_title.length - 1} more
                    </span>
                  </Tooltip>
                </>
              )}
            </>
          ) : (
            "—"
          )}
        </p>
      </div>

      <div style={{ flex: 1, textAlign: "left" }}>
        <CustomParagraph
          fontSize="12px"
          fontWeight="400"
          text={(() => {
            const allUsers =
              item?.send_to
                ?.flatMap((team) =>
                  Array.isArray(team?.users)
                    ? team.users.map((u) => u.name)
                    : []
                )
                ?.filter(Boolean) || [];

            return allUsers.length > 0 ? (
              <>
                {allUsers[0]}
                {allUsers.length > 1 && (
                  <>
                    ,{" "}
                    <Tooltip title={allUsers.slice(1).join(", ")}>
                      <span
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        +{allUsers.length - 1} more
                      </span>
                    </Tooltip>
                  </>
                )}
              </>
            ) : (
              "—"
            );
          })()}
        />
      </div>

      <div>
        {visible ? (
          <Tooltip
           
            title="View in settings"
          >
            <EyeFilled  onClick={() => navigate("/settings/notification")} style={{ fontSize: 16, cursor: "pointer" }} />
          </Tooltip>
        ) : (
          <Dropdown overlay={menu} trigger={["hover"]}>
            <MoreOutlined style={{ fontSize: 16, cursor: "pointer" }} />
          </Dropdown>
        )}
      </div>
    </div>
  );
};

export default NotificationListItem;
